import React from 'react';
import styles from './navigation.module.css';

const Navigation = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const session_state = urlParams.get('session_state');

    return (
        <section id='edit-profile-nav' className={styles.navBar}>
            <div>
                <buton
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                        (window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?session_state=${session_state}`)
                    }
                >
                    <img
                        src={'assets/img/logo.svg'}
                        alt='splendi logo'
                        width={150}
                    />
                </buton>
            </div>
            <ul className={styles.navItems}>
                <li onClick={() => props.changeRoute('account')}>Account</li>
                <li onClick={() => props.changeRoute('password')}>Password</li>
                {/* <li onClick={() => props.changeRoute('authenticator')}>
                    Authenticator
                </li> */}
                <li onClick={() => props.changeRoute('logs')}>Logs</li>
                <li
                    onClick={() =>
                        (window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?session_state=${session_state}`)
                    }
                >
                    Back To Splendi
                </li>
            </ul>
            <div className='d-flex gap-4 align-items-center'>
                {props.userData !== null && props.userData !== undefined ? (
                    <>
                        <span>{`${props.userData.firstName} ${props.userData.lastName}`}</span>
                        <img
                            src='assets/img/generic_avatar.svg'
                            alt='users avatar'
                            width={45}
                        />
                    </>
                ) : (
                    <span
                        style={{ width: '20px', height: '20px' }}
                        className='spinner-border spinner-border-sm'
                    ></span>
                )}
            </div>
        </section>
    );
};

export default Navigation;
